"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalNavigationLogo_component_exports = {};
__export(GlobalNavigationLogo_component_exports, {
  GlobalNavigationLogo: () => GlobalNavigationLogo
});
module.exports = __toCommonJS(GlobalNavigationLogo_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_GreatmindsLogo = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/GreatmindsLogo"));
var import_AppSwitcher = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/AppSwitcher"));
const GlobalNavigationLogo = ({
  href,
  ariaLabel = "Great Minds"
}) => {
  const commonProps = {
    title: "Great Minds",
    iconSize: "inherit",
    color: "#111319"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "a",
    {
      "aria-label": ariaLabel,
      href,
      className: "text-n-100 focus:outline-beige-180 w-12 no-underline focus:outline md:w-36",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "block h-12 w-12 md:hidden", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_AppSwitcher.default,
          {
            iconSize: commonProps.iconSize,
            title: commonProps.title,
            color: commonProps.color
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "hidden md:block", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_GreatmindsLogo.default,
          {
            iconSize: commonProps.iconSize,
            title: commonProps.title,
            color: commonProps.color
          }
        ) })
      ]
    }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalNavigationLogo
});
//# sourceMappingURL=GlobalNavigationLogo.component.js.map